import { StreamWithChatRate } from '../types';

/** A channel can be embedded before Helix answers, including while offline. */
export const channelStream = (login: string): StreamWithChatRate => ({
  id: login,
  user_id: '',
  user_login: login,
  user_name: login,
  game_id: '',
  game_name: '',
  type: '',
  title: '',
  viewer_count: 0,
  started_at: '',
  language: '',
  thumbnail_url: '',
  tag_ids: [],
  is_mature: false,
  chatRate: 0,
  messageCount: 0,
});
